<template>
  <el-form label-position="left" label-width="auto">
    <div class="box-property">
      <el-form-item label="规格选择">
        <el-select :disabled="true" v-model="selectedPropertyNameIds" multiple clearable :multiple-limit=3 @change="handlePropertyNameChange">
          <el-option v-for="propertyName in allPropertyNames" :key="propertyName.id" :label="propertyName.name" :value="propertyName.id" />
        </el-select>
      </el-form-item>

      <el-form-item v-for="propertyName in productPropertyNames" :key="propertyName.id" :label="propertyName.name">
        <el-select v-model="propertyName.property_value_ids"
          filterable multiple clearable
          @change="handleChangeSku">
          <el-option v-for="propertyValue in propertyNameValues(propertyName.name)" :key="propertyValue.id" :label="propertyValue.value" :value="propertyValue.id" />
        </el-select>
      </el-form-item>
    </div>
    <div class="box-sku" v-if="skus.length">
      <p class="title">商品设置</p>
      <el-form inline :disabled="!skuSelected.length">
        <el-form-item label="批量设置:">
        </el-form-item>
        <el-form-item label="原价">
          <el-input v-model="multiplePriceForm.sale_price" @input="handleMultiSkuChange('sale_price', $event)" />
        </el-form-item>
        <el-form-item label="折扣价格">
          <el-input placeholder="0表示没有折扣价" v-model="multiplePriceForm.discount_price" @input="handleMultiSkuChange('discount_price', $event)" />
        </el-form-item>
        <el-form-item label="员工价格">
          <el-input placeholder="0表示没有员工价" v-model="multiplePriceForm.employee_price" @input="handleMultiSkuChange('employee_price', $event)" />
        </el-form-item>
        <el-form-item label="佣金">
          <el-input v-model="multiplePriceForm.commission" @input="handleMultiSkuChange('commission', $event)" />
        </el-form-item>
      </el-form>
      <c-source-table :columns="tableColumns" :table="table" />
    </div>
    <div class="box-color-products" v-if="skus.length">
      <p class="title">不同颜色参数设置</p>
      <el-form-item v-for="color in selectedColor" :key="color" :label="color">
        <div class="color-images">
          <c-upload-form-item
            :limit="20"
            :value="picture_properties[color]"
            :transform-link="src => `${src}`"
            @change="handleColorPictureChange(color, $event)"
          />
          <span class="hint">图片比例1:1，建议尺寸 750x750</span>
        </div>
        <div class="initial-sale-count">
          <div class="color-sale-count">
            <span class="sub-title">初始销量</span>
            <el-input-number :max="999999" :min="0" v-model="colorInitialSaleCounts[color]" @input="handleColorInitialSaleCountChange(color, $event)" />
          </div>
          <div class="color-increase-factors">
            <span class="sub-title">随机增长系数（没填默认为5）</span>
            <el-input-number :max="999999" :min="0" v-model="colorIncreaseFactors[color]" @input="handleColorIncreaseFactorChange(color, $event)" />
          </div>
        </div>
        <div class="color-position">
          <span class="sub-title">权重(从小到大排序)</span>
          <el-input-number :max="999999" :min="0" v-model="colorPositions[color]" @input="handleColorPositionChange(color, $event)" />
        </div>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class Property extends Vue {
  @Prop([Number, String]) id;
  @Prop({ type: Object, default: () => ({}) }) product;
  @Prop({ type: Array, default: () => ([]) }) propTrendingTags;

  allPropertyNames = [];          // 所有的规格名和规格值基础数据
  selectedPropertyNameIds = [];   // 选中规格名ids，和产品添加关联
  productPropertyNames = [];      // 产品下所有商品的规格名和规格参数
  picture_properties = {};        // 颜色对应图片
  skus = [];                      // 组合的sku数据，sku table基础数据
  skuSelected = [];
  multiplePriceForm = {};
  deletedGoodsIds = [];
  trendings = {};                 // 颜色产品关联的逛
  trendingTags = [];
  colorProduct = {};
  colorInitialSaleCounts = {};    // 不同颜色商品初始销量
  colorIncreaseFactors = {};      // 不同颜色商品初始销量随机增长系数
  colorPositions = {};            // 不同颜色商品权重

  get table() {
    return {
      data: this.skus,
      events: {
        'selection-change': this.handleTableSelectionChange
      }
    }
  }

  get productPropertyNameIds() {
    return _.map(this.productPropertyNames, (ele) => ele.id);
  }

  get tableColumns() {
    const properties_columns = [{
      prop: '',
      type: 'selection'
    }].concat(_.map(this.productPropertyNames, (ele) => {
      return ({
        prop: `property_${ele.id}`,
        label: ele.name
      })
    }));

    return properties_columns.concat([{
      prop: 'sale_price',
      label: '单价(元)',
      width: 180,
      renderCell: (h, scope) => <el-input-number props={{ max: 999999, min: 0 }} value={scope.row.sale_price} onInput={this.handleSkuChange('sale_price', scope)} />
    }, {
      prop: 'discount_price',
      label: '折扣价格(元)',
      width: 180,
      renderCell: (h, scope) => <el-input-number props={{ max: 999999, min: 0 }} value={scope.row.discount_price} onInput={this.handleSkuChange('discount_price', scope)} />
    }, {
      prop: 'employee_price',
      label: '员工价格(元)',
      width: 180,
      renderCell: (h, scope) => <el-input-number props={{ max: 999999, min: 0 }} value={scope.row.employee_price} onInput={this.handleSkuChange('employee_price', scope)} />
    }, {
      prop: 'commission',
      label: '佣金(元)',
      width: 180,
      renderCell: (h, scope) => <el-input-number props={{ max: 999999, min: 0 }} value={scope.row.commission} onInput={this.handleSkuChange('commission', scope)} />
    }, {
      prop: 'sku_id',
      label: 'SKU编码',
      width: 180,
      renderCell: (h, scope) => <el-input value={scope.row.sku_id} onInput={this.handleSkuChange('sku_id', scope)} />
    }, {
      prop: 'inventory_quantity',
      label: '数量',
      width: 180,
      renderCell: (h, scope) => <el-input-number props={{ min: 0 }} value={scope.row.inventory_quantity} onInput={this.handleSkuChange('inventory_quantity', scope)} />
    }, {
      prop: 'action',
      label: '操作',
      renderCell: (h, scope) => {
        return <el-button type="text" onClick={() => this.handleRemoveSku(scope)}>删除</el-button>
      }
    }]);
  }

  get propertyNameValues() {
    const propertyNames = this.allPropertyNames;

    return (propertyName) => {
      if (propertyNames.length > 0) {
        const property = _.find(propertyNames, { 'name': propertyName });
        return property.property_values;
      }
    }
  }

  get productColorPropertyName() {
    return this.productPropertyNames.find(ele => ele.name === '颜色');
  }

  get selectedColor() {
    let colorPropertyValues = [];
    const colorPropertyName = this.productColorPropertyName;
    if (colorPropertyName) {
      colorPropertyValues = _.map(colorPropertyName.property_values, ele => ele.value);
    }
    return colorPropertyValues;
  }

  get allColorIds() {
    const colorPropertyName = this.allPropertyNames.find(ele => ele.name === '颜色');
    return _.map(colorPropertyName.property_values, (ele) => ele.id);
  }

  async mounted() {
    const [{ data: propertyNames }] = await Promise.all([
      this.$request.get('/property_names', { params: { per_page: 100 } }),
      this.getSkus()
    ])
    this.allPropertyNames = propertyNames;
    if (this.productPropertyNames.length === 0) {
      this.productPropertyNames = propertyNames.map(ele => ({ id: ele.id, name: ele.name }));
      this.selectedPropertyNameIds = _.map(this.productPropertyNames, ele => ele.id);
    }
  }

  async getSkus() {
    if (this.id) {
      const goodses = await this.$request.get(`/products/${this.id}/goodses_with_properties`);
      this.skus = goodses.map(item => ({
        ...item,
        sale_price: item.price
      }));
    }
  }

  handleTableSelectionChange(rows) {
    this.skuSelected = rows;
  }

  // 批量设置
  handleMultiSkuChange(prop, value) {
    this.skuSelected.forEach(item => item[prop] = value);
  }

  handleSkuChange(prop, scope) {
    return (value) => {
      this.$set(this.skus[scope.$index], prop, value);
    }
  }

  // 移除sku的时候，规格的选择需要级联响应
  handleRemoveSku({ $index }) {
    const propertyIds = this.selectedPropertyNameIds;
    const { productPropertyNames } = this;

    const [{
      [`property_${propertyIds[0]}`]: propertyValue0,
      [`property_${propertyIds[1]}`]: propertyValue1,
      [`property_${propertyIds[2]}`]: propertyValue2,
      id
    }] = this.skus.splice($index, 1);

    if (id) this.deletedGoodsIds.push(id); // 标记为已移除

    _.filter([propertyValue0, propertyValue1, propertyValue2], (propertyValue, index) => {
      // 分别判断对应的属性是否还有sku，没有则去掉相应的属性值
      if (propertyValue && !this.skus.find(item => item[`property_${propertyIds[index]}`] === propertyValue)) {
        const foundIndex = productPropertyNames.findIndex(ele => ele.id === propertyIds[index]);
        const removedValuePropertyName = productPropertyNames[foundIndex];
        const newPropertyValue = removedValuePropertyName.property_values.filter(ele => ele.value !== propertyValue);
        productPropertyNames[foundIndex].property_values = newPropertyValue;
        productPropertyNames[foundIndex].property_value_ids = newPropertyValue.map(ele => ele.id);
        this.productPropertyNames = productPropertyNames;
      }
    })
  }

  handlePropertyNameChange() {
    const selectedPropertyNameIds = Array.from(this.selectedPropertyNameIds);
    const addedPropertyNameId = _.difference(selectedPropertyNameIds, this.productPropertyNameIds)[0];
    const removedPropertyNameId = _.difference(this.productPropertyNameIds, selectedPropertyNameIds)[0];

    if (addedPropertyNameId) {
      const addedPropertyName = this.getPropertyNameById(addedPropertyNameId);
      addedPropertyName['property_values'] = [];
      this.productPropertyNames.push(addedPropertyName);
    }
    if (removedPropertyNameId) {
      this.productPropertyNames = _.filter(this.productPropertyNames, (ele) => ele.id !== removedPropertyNameId)
    }
  }

  updateProductPropertyValues() {
    this.productPropertyNames = _.compact(_.map(this.productPropertyNames, (ele) => {
      if (ele.property_values === undefined) ele.property_values = [];
      if (ele.property_value_ids.length !== ele.property_values.length) {
        const propertyValueIds = _.map(ele.property_values, ele => ele.id);

        const newPropertyValueId = _.difference(ele.property_value_ids, propertyValueIds)[0];
        const removedPropertyValueId = _.difference(propertyValueIds, ele.property_value_ids)[0];

        if (newPropertyValueId) ele.property_values.push(this.getPropertyValuesById(newPropertyValueId));
        if (removedPropertyValueId) ele.property_values = _.filter(ele.property_values, ele => ele.id !== removedPropertyValueId);
      }
      return ele;
    }));
    // 保持property_values和对应的property_value_ids一致
    this.selectedPropertyNameIds = this.productPropertyNames.map(ele => ele.id);
  }

  async handleChangeSku() {
    this.updateProductPropertyValues(); // 属性值改变的时候，需要更改产品对应的productPropertyNames里的property_values值
    const skus = this.composeSkus();

    // 删除的商品
    const removedSkuIds = _.difference(this.skus.map(ele => ele.id), skus.map(ele => ele.id));
    if ((removedSkuIds || []).length > 0) { this.deletedGoodsIds.push(removedSkuIds); }

    this.skus = skus;
  }

  handleColorPictureChange(color, value) {
    this.$set(this.picture_properties, color, value);
  }

  handleColorInitialSaleCountChange(color, value) {
    this.$set(this.colorInitialSaleCounts, color, value);
  }

  handleColorIncreaseFactorChange(color, value) {
    this.$set(this.colorIncreaseFactors, color, value);
  }

  handleColorPositionChange(color, value) {
    this.$set(this.colorPositions, color, value);
  }

  handleTrendingsChange(color, attr, value) {
    if (this.trendings[color] === undefined) {
      this.$set(this.trendings, color, {});
    }
    if (attr === 'tag_list') {
      this.trendingTags = _.uniq(this.trendingTags.concat(value));
    }
    this.trendings[color][attr] = value;
  }

  getPropertyNameById(propertyId) {
    const propertyName = _.find(this.allPropertyNames, (item) => item.id === propertyId);
    return _.omit(propertyName, ['property_values'])
  }

  getPropertyValuesById(id) {
    const allPropertyValues =  _.flatten(this.allPropertyNames.map(item => item.property_values));
    return allPropertyValues.find(item => item.id === id);
  }

  submit() {
    let colorId = null;
    const picture_properties = _.filter(_.map(this.picture_properties, (new_pictures_urls, color_name) => {
      return { new_pictures_urls, color_name }
    }), ele => this.selectedColor.indexOf(ele.color_name) !== -1);
    const form = {
      goodses_attributes: this.skus.map(sku => {
        colorId = _.find(sku.property_value_ids, ele => this.allColorIds.includes(ele));
        return ({
          color_property_value_id: colorId,
          size_property_value_id: _.find(sku.property_value_ids, ele => ele !== colorId),
          ..._.pick(sku, ['id', 'sku_id', 'sale_price', 'discount_price', 'member_price', 'employee_price', 'commission', 'color_product_id', 'inventory_quantity'])
        });
      }),
      deleted_goods_ids: this.deletedGoodsIds.join(','),
      property_name_ids: this.selectedPropertyNameIds.join(','),
      trendings: this.trendings,
      picture_properties: picture_properties,
      color_products_attributes: {
        color_initial_sale_counts: _.pick(this.colorInitialSaleCounts, this.selectedColor),
        color_increase_factors: this.colorIncreaseFactors,
        color_positions: this.colorPositions
      }
    }
    return form;
  }

  @Watch('propTrendingTags', { immediate: true })
  onPropTrendingTagsChange(propTrendingTags) {
    if (propTrendingTags) {
      this.trendingTags = propTrendingTags || [];
    }
  }

  @Watch('product', { immediate: true })
  onProductChange(product) {
    if (product.id) {
      this.productPropertyNames = product.property_names;
      this.selectedPropertyNameIds = _.map(this.productPropertyNames, ele => ele.id);
      this.picture_properties = _.cloneDeep(product.picture_properties);
      this.colorInitialSaleCounts = _.cloneDeep(product.color_initial_sale_counts);
      this.colorIncreaseFactors = _.cloneDeep(product.color_increase_factors)
      this.colorPositions = _.cloneDeep(product.color_positions);
      this.trendings = _.cloneDeep(product.human_trendings);
    }
  }

  composeSkus() {
    const skus = [];
    const [property1, property2, property3] = this.productPropertyNames;
    const baseAttr = {
      sale_price: '',
      discount_price: '',
      member_price: '',
      employee_price: '',
      sku_id: '',
      inventory_quantity: 0,
      commission: 0
    }

    if (property3) {
      property1.property_values.forEach(propertyValue1 => {
        property2.property_values.forEach(propertyValue2 => {
          property3.property_values.forEach(property_3_value => {
            const current = this.skus.find(item =>
              item[`property_${property1.id}`] === property1.name &&
                item[`property_${property2.id}`] === property2.name &&
                  item[`property_${property3.id}`] === property3.name
            ) || {};
            skus.push({
              [`property_${property1.id}`]: propertyValue1.value,
              [`property_${property2.id}`]: propertyValue2.value,
              [`property_${property3.id}`]: property_3_value.value,
              property_value_ids: [propertyValue1.id, propertyValue2.id, property_3_value.id],
              ...baseAttr,
              ...current
            });
          })
        });
      });
    } else if (property2) {
      property1.property_values.forEach(propertyValue1 => {
        property2.property_values.forEach(propertyValue2 => {
          const current = this.skus.find(item =>
            item[`property_${property1.id}`] === propertyValue1.value &&
              item[`property_${property2.id}`] === propertyValue2.value
          ) || {};
          skus.push({
            [`property_${property1.id}`]: propertyValue1.value,
            [`property_${property2.id}`]: propertyValue2.value,
            property_value_ids: [propertyValue1.id, propertyValue2.id],
            ...baseAttr,
            ...current
          });
        });
      });
    } else if (property1) {
      property1.property_values.forEach(propertyValue1 => {
        const current = this.skus.find(item => item[`property_${property1.id}`] === property1.name) || {};
        skus.push({
          [`property_${property1.id}`]: propertyValue1.value,
          property_value_ids: [propertyValue1.id],
          ...baseAttr,
          ...current
        });
      })
    }
    return skus;
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .el-input-number {
    width: 120px;

    .el-input-number__increase, .el-input-number__decrease {
      width: 28px;
    }

    .el-input__inner {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .hint {
      font-size: 12px;
      color: gray;
      line-height: 24px;
  }

  .sub-title {
    margin-right: 10px;
    color: #838588;
    font-size: 13px;
  }

  .box-color-products {
    .initial-sale-count {
      display: inline-flex;
      margin-top: 12px;

      .color-sale-count {
        margin-right: 20px;

        .sub-title {
          margin-left: 60px;
        }
      }
    }

    .color-position {
      margin-top: 12px;
    }
  }

  .box-trendings {
    .title {
      margin-top: 50px;
    }

    .el-select {
      margin-top: 10px;
      width: 600px;
    }
  }
</style>
